import { useApiQuery } from '@tasama/api-client-query';
import { QUERY_CACHE_TIME } from '@/config/query-config';
import type { ServiceDetailsResponse } from '../types';

interface UseServiceDetailsQueryParams {
  srAttemptId: string;
  enabled?: boolean;
}

export const SERVICE_DETAILS_QUERY_KEY = ['services', 'details'] as const;

export const getServiceDetailsQueryKey = (srAttemptId: string) => [
  ...SERVICE_DETAILS_QUERY_KEY,
  srAttemptId,
];

export const useServiceDetailsQuery = ({
  srAttemptId,
  enabled = true,
}: UseServiceDetailsQueryParams) => {
  const queryKey = getServiceDetailsQueryKey(srAttemptId);

  const {
    data,
    isLoading,
    error: queryError,
    refetch,
  } = useApiQuery<ServiceDetailsResponse>(
    queryKey,
    `/services/service-request/${srAttemptId}/details`,
    {
      method: 'GET',
      staleTime: 0,
      gcTime: QUERY_CACHE_TIME.GC_TIME,
      enabled,
    }
  );

  return {
    serviceDetails: data ?? null,
    loading: isLoading,
    error: queryError?.message ?? null,
    errorCode: typeof queryError?.code === 'number' ? queryError.code : null,
    refresh: refetch,
  };
};
